import { type FC } from 'react';
import { Navigate } from 'react-router-dom';

const ImportExportPage: FC = () => <Navigate to="/backup" replace />;

export default ImportExportPage;
